export default __webpack_public_path__ + "static/media/customer4.1caf67ad.svg";